import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomSwitch } from 'Components/StyledComponents';
import { FeatureFlag, getAllFeatureFlags, setFeatureFlag } from 'Utils/FeatureFlags';

const FEATURE_FLAG_LABELS: Record<FeatureFlag, string> = {
  [FeatureFlag.USE_2_5D_ROADMAP]: 'Layered roadmap and repertoire stages',
  [FeatureFlag.USE_ERROR_FEEDBACK]: 'Error feedback',
  [FeatureFlag.USE_AUDIO_RECOGNITION]: 'Audio recognition input',
  [FeatureFlag.USE_ANNOUNCEMENT_MODAL]: 'Announcement modal',
  [FeatureFlag.USE_REPERTOIRE_CREATE]: 'Repertoire create editor',
  [FeatureFlag.USE_REPERTOIRE_LIBRARY]: 'Repertoire library',
  [FeatureFlag.USE_REPERTOIRE_PLAYBACK_MODES]: 'Repertoire playback modes',
  [FeatureFlag.USE_REPERTOIRE_FILTERING]: 'Repertoire filtering',
  [FeatureFlag.USE_HISTORY_OF_PIANO_MUSIC]: 'History of piano music',
  [FeatureFlag.USE_COMMUNITY_HUB]: 'Community hub (preview)',
  [FeatureFlag.USE_TEACHER_ASSIGNMENTS]: 'Teacher assignments (development pilot)',
  [FeatureFlag.USE_EXERCISES]: 'Exercises section',
  [FeatureFlag.DEBUG_DUMMY_MIDI]: 'Debug dummy MIDI (computer keyboard)',
  [FeatureFlag.USE_ERGOBOT_FINGERING]: 'Live finger numbers (sight reading)',
};

const ExperimentalFeatures = () => {
  const [flags, setFlags] = useState<Record<FeatureFlag, boolean>>(() => getAllFeatureFlags());

  const handleToggle = (flag: FeatureFlag) => {
    const next = !flags[flag];
    setFeatureFlag(flag, next);
    setFlags((prev) => ({ ...prev, [flag]: next }));
  };

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', overflow: 'scroll' }}>
      <Box
        sx={{
          marginLeft: '50px',
          width: '600px',
          backgroundColor: 'black',
          borderRadius: '5px',
        }}
      >
        <Box
          sx={{
            color: 'white',
            textAlign: 'left',
            marginLeft: '24px',
            marginRight: '24px',
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              marginTop: '20px',
              marginBottom: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '26px',
              letterSpacing: '0.01em',
              color: '#FFFFFF',
              fontFamily: 'Lato',
            }}
          >
            Experimental Features
          </Box>

          <Box sx={{ marginBottom: '20px', fontFamily: 'Lato' }}>
            {Object.values(FeatureFlag).map((flag) => (
              <Box
                key={flag}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '8px',
                }}
              >
                <CustomSwitch
                  checked={flags[flag]}
                  onChange={() => handleToggle(flag)}
                  slotProps={{ input: { role: 'switch', 'aria-label': FEATURE_FLAG_LABELS[flag] } }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '25px',
                    marginLeft: '8px',
                  }}
                >
                  {FEATURE_FLAG_LABELS[flag]}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ExperimentalFeatures;
